import React from 'react'
import isEmpty from 'lodash/isEmpty'
import noop from 'lodash/noop'
import axios from 'axios'

import { captureException } from '@util/sentry'
import { withGlobalContext } from '@util/global_context'

const EmailForm = config => Component => {
  class EmailForm extends React.Component {
    state = {
      submitting: false,
      error: false,
      success: false,
      email: '',
      name: '',
      organization: '',
      message: '',
      validationErrors: {},
    }

    setFormValue = (name, value) => {
      this.setState({
        [name]: value,
        error: false,
        success: false,
        validationErrors: {},
      })
    }

    setNameValue = e => this.setFormValue('name', e.target.value)
    setEmailValue = e => this.setFormValue('email', e.target.value)
    setOrganizationValue = e => this.setFormValue('organization', e.target.value)
    setMessageValue = e => this.setFormValue('message', e.target.value)

    validate = data => {
      if (config.validate) return config.validate(data)
      return false
    }

    handleSubmit = async e => {
      e.preventDefault()
      this.setState({ submitting: true })

      const validationErrors = this.validate(this.state)
      if (!isEmpty(validationErrors)) {
        this.setState({
          submitting: false,
          validationErrors: validationErrors,
        })
        return
      }

      const onSuccess = this.props.onSuccess || config.onSuccess || noop
      const content = {
        subject: 'New Support Form Submission',
        email: this.state.email,
        name: this.state.name,
        organization: this.state.organization,
        message: this.state.message,
      }
      axios
        .post(`/api/email`, content)
        .then(() => {
          this.setState({
            submitting: false,
            error: false,
            success: true,
            email: '',
            message: '',
            name: '',
            organization: '',
          })
        })
        .then(onSuccess)
        .catch(e => {
          captureException(e)
          this.setState({
            submitting: false,
            error: true,
          })
        })
    }

    render() {
      const formProps = {
        form: {
          ...this.state,
        },
        setNameValue: this.setNameValue,
        setEmailValue: this.setEmailValue,
        setOrganizationValue: this.setOrganizationValue,
        setMessageValue: this.setMessageValue,
        handleSubmit: this.handleSubmit,
      }

      return <Component {...this.props} {...formProps} />
    }
  }

  return withGlobalContext(EmailForm)
}

export default EmailForm
